import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["assetCoordinates", "priority"],
  _excluded2 = ["personalizations"];
import { sortByPriority } from 'personalization-lib/utils/sorting';
import { getSegment } from 'personalization-lib/utils/personalizationStrategy/segments';
const mapToPersonalizedAsset = _ref => {
  let {
      assetCoordinates,
      priority
    } = _ref,
    otherVariantFields = _objectWithoutPropertiesLoose(_ref, _excluded);
  return {
    assetCoordinates,
    segmentIdentifier: getSegment(otherVariantFields),
    priority
  };
};
export const getAllStrategyAssets = _ref2 => {
  let {
      personalizations
    } = _ref2,
    mainAsset = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return [...sortByPriority(personalizations).map(mapToPersonalizedAsset), {
    assetCoordinates: mainAsset.assetCoordinates,
    segmentIdentifier: undefined,
    priority: undefined
  }];
};
export const getAssetIds = variants => variants.map(variant => variant.assetCoordinates.id);
export const getAssetDetails = ({
  assetCoordinates
}) => ({
  assetType: assetCoordinates.source,
  assetId: assetCoordinates.id.toString()
});